module.exports = __webpack_public_path__ + "assets/img/F2.7d3b2036.png";